module.exports = __webpack_public_path__ + "img/pad.824cd1e1.png";